module.exports = __webpack_public_path__ + "img/ANTENNA WAVES LIME.085dba3.svg";